import React, { useEffect, useState } from "react";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../styles/materialPagination";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { useHistory } from "react-router-dom";
import Notification from "../../../elements/notification/Notification";
import RangeFeeList from "./RangeFeeList";
import RangeFeeFilter from "./RangeFeeFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import RangeFeeInvoice from "./RangeFeeInvoice";

const RangeFeeContainer = ({ match }) => {
  const [fees, setFees] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [refetch, setRefetch] = useState(false);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "rangeFee", false, true),
    "baseFee.service.name": checkFilterItem(history, "baseFee.service.name", null),
    "baseFee.paymentSystem.name": checkFilterItem(history, "baseFee.paymentSystem.name", null),
    "baseFee.currency.asset": checkFilterItem(history, "baseFee.currency.asset", null),
    "baseFee.type": checkFilterItem(history, "baseFee.type", null),
    "percent[gte]": checkFilterItem(history, "percent[gte]", null, true),
    "percent[lte]": checkFilterItem(history, "percent[lte]", null, true),
    "constant[gte]": checkFilterItem(history, "constant[gte]", null, true),
    "constant[lte]": checkFilterItem(history, "constant[lte]", null, true),
    "minAmount[gte]": checkFilterItem(history, "minAmount[gte]", null, true),
    "minAmount[lte]": checkFilterItem(history, "minAmount[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchRangeFee = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/range-fees" + filterUrl + "&user.id=" + match.params.id, userAuthenticationConfig()).
      then(response => {
        if (response.status === 200) {
          setFees(response.data["hydra:member"]);
          setTotalPageCount(response.data["hydra:totalPageCount"]);
        }
      }).
      catch(error => {
        setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
      });
  };

  useEffect(() => {
    fetchRangeFee();
  }, [filterData, refetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <div className="content-left">
          <RangeFeeFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
        </div>
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
        <RangeFeeInvoice
          fetchRangeFee={fetchRangeFee}
          userId={match.params.id}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <RangeFeeList
        fees={fees}
        refetch={refetch}
        setRefetch={setRefetch}
        notification={notification}
        setNotification={setNotification}
      />
      {totalPageCount > 1  &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </>
  );
};

export default RangeFeeContainer;